import { InjectionToken } from '@angular/core';

export interface CmsPageRouteContext {
  readonly basePath: string;
  readonly urlSuffix?: string;
}

export const CMS_PAGE_ROUTE_CONTEXT: InjectionToken<CmsPageRouteContext> =
  new InjectionToken<CmsPageRouteContext>('CMS_PAGE_ROUTE_CONTEXT');
